import { ArrowRight, Sparkles } from "lucide-react";

export default function Solution() {
  return (
    <section
      data-testid="wc-solution"
      className="relative bg-[#f8f6ff] py-20 sm:py-28 overflow-hidden"
    >
      <div className="absolute -top-24 right-0 w-96 h-96 rounded-full bg-[#c5b4ff]/40 blur-3xl" />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#30265b] text-[#d3fc3a] font-nav font-semibold text-xs rounded-full px-3 py-1 mb-5">
              <Sparkles size={14} /> The solution
            </div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#30265b] leading-[1.1]">
              Meet the WinCampaign DFY Business Growth Accelerator™
            </h2>
            <p className="mt-5 text-lg text-gray-700 leading-relaxed">
              Not another marketing service. Not another course. A premium,
              done-for-you growth program where a dedicated team runs your
              social presence, generates qualified leads, and — with ELITE —
              even conducts Discovery Calls on your behalf.
            </p>
            <p className="mt-4 text-lg text-gray-700 leading-relaxed">
              You focus on relationships and closing subscribers. We handle
              the marketing engine that fills your pipeline.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#pricing"
                data-testid="wc-solution-cta"
                className="bg-[#673dfc] text-white font-display font-semibold rounded-full px-6 py-3 hover:bg-[#522ce0] transition-colors flex items-center gap-2"
              >
                Yes, Help Me Build My $10K/Month Business <ArrowRight size={16} />
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden bg-[#30265b] p-8 sm:p-10 text-white shadow-2xl shadow-[#673dfc]/20">
              <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#673dfc]/40 blur-2xl" />
              <div className="relative">
                <div className="text-sm font-nav text-[#d3fc3a] uppercase tracking-widest font-semibold">
                  Your Dedicated Team
                </div>
                <div className="mt-2 font-display font-extrabold text-2xl leading-tight">
                  Content · Leads · Discovery · Growth Review
                </div>
                <div className="mt-6 space-y-3 text-sm">
                  {[
                    "Weekly branded content published for you",
                    "Qualified prospects delivered every month",
                    "Monthly 1:1 growth strategy review",
                    "ELITE: your Growth Advisor closes on your behalf",
                  ].map((line) => (
                    <div
                      key={line}
                      className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3"
                    >
                      <div className="w-2 h-2 rounded-full bg-[#d3fc3a] mt-2 flex-shrink-0" />
                      <div className="text-white/90">{line}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
